module.exports = __webpack_public_path__ + "static/media/industrial-goods-and-services.93815feb.svg";